import { render, staticRenderFns } from "./postil.vue?vue&type=template&id=5ac6b908&"
import script from "./postil.vue?vue&type=script&lang=js&"
export * from "./postil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports